// extracted by mini-css-extract-plugin
module.exports = {"root":"az_MM","--size":"az_NM","--auto":"az_OM"};